<template>
  <v-container fluid>
    <v-dialog
      persistent
      v-model="editModal"
      :active="editModal"
      :on-cancel="
        () => {
          editModal = false
        }
      "
      max-width="600"
    >
      <form @submit.prevent="editSections()">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Edit Sections of {{ selectedClassName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="editModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" v-for="(sect, index) in selectedSectionInfo" :key="index">
                <v-text-field title="Special characters not allowed!" required="" type="text" maxLength="50" :label="'Section Name '+(index+1)" v-model="sect.name" placeholder="Ex: A">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn v-if="isWrite" type="submit" color="accent">Edit</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <v-dialog
      ref="sectionEdit"
      persistent
      v-model="modalOk"
      :active="modalOk"
      :on-cancel="
        () => {
          modalOk = false
        }
      "
      max-width="600"
    >
      <form @submit.prevent="Save">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Add Section</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="modalOk = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Section Name" v-model="sectionName" placeholder="Ex: A" required> </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn v-if="isWrite" color="accent" @click="addSection">Add</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <material-card icon="mdi-clipboard-text" inline title="Class List">
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-card-title>
          <!-- Total Records : {{ total }} -->
          <v-spacer></v-spacer>
        </v-card-title>
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width: 350px"
        />
        <v-btn v-if="isWrite" elevation="1" v-on:click="addClass()" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
          <v-icon left>mdi-plus</v-icon>
          Add
        </v-btn>
      </v-card-text>
      <v-divider class="my-0" />
      <v-data-table
        :search.sync="search"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="searchFilterArray"
      >
        <template v-slot:item.sections="{ item }">
          <span v-for="(section, i) in item.studentSections" :key="i">{{ section.name }}, </span>
        </template>
        <template v-slot:item.isActive="{ item }">
          {{ item.isActive ? 'Active' : 'Inactive' }}
        </template>
        <template v-if="isWrite" v-slot:item.actions="{ item }">
          <v-btn v-show="item.studentSections.length > 0" outlined @click="editModalOpen(item)" class="px-2 ml-1 ma-1" color="success" min-width="0" small> Edit Section </v-btn>
          <v-btn outlined @click="modalOpen(item.id)" class="px-2 ml-1 ma-1" color="accent" min-width="0" small> Add Section </v-btn>
        </template>
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import _ from 'lodash'
export default {
  name: 'classList',
  components: { MaterialCard },
  data () {
    return {
      classData: [],
      search: '',
      isLoading: false,
      searchTerm: '',
      total: '',
      modalOk: false,
      sectionName: '',
      selectedClass: '',
      selectedClassName: '',
      isWrite: false,
      searchFilterArray: [],
      editModal: false,
      selectedSectionInfo: [],
      headers: [
        { text: 'Name', sortable: true, value: 'name' },
        { text: 'Section', sortable: false, value: 'sections' },
        { text: 'Active/Inactive', sortable: true, value: 'isActive' },
        { text: 'Action', sortable: false, value: 'actions', align: 'center' }
      ]
    }
  },
  created () {
    this.getClassData()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  methods: {
    addSection: async function () {
      let obj = {
        classID: this.selectedClass,
        name: this.sectionName,
        position: '0'
      }
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.post(`${constants.API_URL}/api/student/section`, obj)
        this.loadingComponent.close()
        this.modalOk = false
        this.getClassData()
        this.sectionName = ''
        this.okMsg('Section added successfully!')
      } catch (e) {
        this.loadingComponent.close()
        this.modalOk = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While Saving Section: ${errorMessage}`)
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.classData
        this.total = this.searchFilterArray.length
      } else {
        this.searchFilterArray = _.filter(
          this.classData,
          (item) => (item && item.name.toLowerCase().search(value.toLowerCase()) >= 0) || item.studentSections.some((a) => a.name.toLowerCase().search(value.toLowerCase()) >= 0)
        )
        this.total = this.searchFilterArray.length
      }
    },
    modalOpen (id) {
      this.modalOk = true
      this.selectedClass = id
    },
    editModalOpen (ele) {
      this.editModal = true
      this.selectedClass = ele.id
      this.selectedClassName = ele.name
      this.selectedSectionInfo = JSON.parse(JSON.stringify(ele.studentSections))
      this.selectedSectionInfo = this.selectedSectionInfo.map((item) => {
        item.prevName = item.name
        return item
      })
    },
    editSections: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let editedSections = this.selectedSectionInfo
          .filter((item) => item.prevName !== item.name)
          .map((item) => {
            return {
              id: item.id,
              name: item.name
            }
          })
        if (editedSections.length === 0) {
          this.loadingComponent.close()
          return this.$buefy.toast.open({
            message: 'Atleast one section needed to be edited!',
            type: 'is-danger',
            duration: 5000
          })
        }
        // Validation Start
        const pattern = /[^a-zA-Z0-9]|_/g // Special characters except hypen /[^a-zA-Z0-9-]|_/g
        for (let sect of editedSections) {
          sect.name = sect.name.trim()
          if (sect.name === '') {
            return this.$buefy.toast.open({
              message: 'Section name cannot be empty!',
              type: 'is-danger',
              duration: 5000
            })
          } else if (pattern.test(sect.name)) {
            return this.$buefy.toast.open({
              message: 'Special characters are not allowed except!',
              type: 'is-danger',
              duration: 5000
            })
          }
        }
        // Validation End
        const { data } = await http.put(`${constants.API_URL}/api/student/section-update`, {
          classID: this.selectedClass,
          sections: editedSections
        })
        this.okMsg(data)
        this.loadingComponent.close()
        this.editModal = false
        this.getClassData()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 5000
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    getClassData: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=false`)
        this.total = data.length
        this.classData = data
        this.searchFilterArray = this.classData
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    addClass () {
      this.$router.push({ name: 'addClass' })
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
